var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("MantenedorGrid", { attrs: { "grid-options": _vm.gridOptions } }),
      _vm.mostrarModalVerDetalle
        ? _c("VerAlertaVehiculoModal", {
            attrs: {
              lstAlertasBase: _vm.lstAlertasBase,
              alertaVehiculo: _vm.alertaVehiculo,
              alertaConfig: _vm.alertaConfig
            },
            on: {
              cerrar: function($event) {
                return _vm.handleCierreModal()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }